export default {
  slug: "databao",
  code: "DBAO",
  label: "Databao",
  hasGrid: true,
  hasBlackText: true,
  krakenDir: "Databao",
  gridColor: "#d1d1d2",
  logoFamily: "databao",
};
